import { colors } from '@mui/material';

const darkGray = '#3E3E3E';
export const colorPalette = ['#4e5775', '#3859e3', '#37ddf3', '#a9fecc', '#ccf1cd', '#0c4e8c', '#f44336'];

const customColors = {
  primary: '#7BE8F7'
};

export default {
  type: 'dark',
  primary: {
    contrastText: darkGray,
    main: customColors.primary
  },
  secondary: {
    contrastText: darkGray,
    main: colorPalette[1]
  },
  error: {
    contrastText: darkGray,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  success: {
    main: '#DEEFE5',
    dark: '#0B7C3D'
  },
  errorStatus: {
    main: '#FAE2E2',
    dark: '#D10E0C'
  },
  primaryStatus: {
    main: '#EAF2FD',
    dark: colorPalette[1]
  },
  warningStatus: {
    main: '#FDEDDE',
    dark: '#DC6700'
  },
  danger: '#EB5757',
  warning: {
    main: '#f2994a'
  },
  text: {
    primary: '#C9CED8',
    secondary: '#888a91',
    link: colorPalette[1]
  },
  header: {
    default: '#ffff',
    primaryColor: colorPalette[1]
  },
  sectionHeader: {
    primary: '#fff'
  },
  input: {
    background: '#F6F9FE',
    borderColor: '#A7AEBD'
  },
  link: colorPalette[1],
  icon: customColors.primary,
  background: {
    default: '#343434',
    paper: '#3D3D3D'
  },
  table: {
    row: {
      selected: {
        backgroundColor: '#2C2C2C'
      }
    }
  },
  colorPalette,
  divider: colors.grey[200],
  gray: {
    dark: '#546e7a',
    main: '#8998AF',
    light: '#CED4DD'
  },
  button: {
    success: {
      background: '#6FCF9740',
      color: '#46A06B'
    },
    error: {
      background: '#EB575733',
      color: '#EB5757'
    }
  },
  alerts: {
    error: {
      background: '#FF9999',
      iconBackground: '#FF0000',
      color: '#CA0101',
      iconColor: '#EFB8B8'
    },
    info: {
      background: '#87EBF8',
      iconBackground: '#37c8f1',
      color: '#3859E3',
      iconColor: '#FFF'
    },
    warning: {
      background: '#F8E4A5',
      iconBackground: '#F2C94C',
      color: '#F97501',
      iconColor: '#F2994A'
    }
  },
  transactions: {
    status: {
      completed: '#6FCF97',
      pending: '#95A8ED',
      cancelled: '#B1B1B1',
      declined: '#EB5757'
    },
    category: {
      background: {
        notSupported: '#FAE2E2',
        supported: '#DFEBFA'
      },
      color: {
        notSupported: '#EB5757'
      }
    }
  },
  flexflowEmployee: {
    status: {
      not_enabled: '#B1B1B1',
      enabled: '#3859E3',
      active: '#6FCF97',
      disabled: '#EB5757',
      blocked: '#0E0E0E'
    }
  },
  flexflowCard: {
    status: {
      notRequested: '#B1B1B1',
      active: '#6FCF97',
      unactivated: '#3859E3',
      terminated: '#0E0E0E',
      suspended: '#95A8ED'
    }
  }
};
